module.exports = __webpack_public_path__ + "img/Dantam Hair 54.334dec56.jpg";